import type { RouteRecordRaw } from 'vue-router'
import { getSurveyHome, guardMySurveys, guardSurveyAccess, guardSurveyManage, guardSurveySettingsAccess } from '@/config/router/navigationsGuards/guardSurvey'

const MODULE_NAME = 'SURVEYS'
const MODULE_ID = 12

const surveyRoutes: Array<RouteRecordRaw> = [
  // Links of the mails sent by the API (legacy paths)
  {
    path: '/surveyPortalFormular/:surveyId',
    redirect: to => ({ name: 'SurveyAnswer', params: { surveyId: to.params.surveyId } }),
  },
  {
    path: '/surveyDetails/:surveyId',
    redirect: to => ({ name: 'Survey', params: { surveyId: to.params.surveyId } }),
  },
  {
    path: '/survey',
    meta: {
      requiresAuth: true,
    },
    beforeEnter: [guardSurveyAccess],
    children: [
      {
        path: '',
        name: 'SurveyHome',
        redirect: () => getSurveyHome(),
      },
      {
        path: 'list',
        name: 'Surveys',
        component: () => import('@/views/survey/List.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.list',
        },
        beforeEnter: [guardSurveyManage],
      },
      {
        path: 'create',
        name: 'SurveyCreation',
        component: () => import('@/views/survey/SurveyEdit.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.create',
        },
        beforeEnter: [guardSurveyManage],
      },
      {
        path: 'mine',
        name: 'MySurveys',
        component: () => import('@/views/survey/MySurveys.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.mine',
        },
        beforeEnter: [guardMySurveys],
      },
      {
        path: 'settings',
        name: 'SurveySettings',
        component: () => import('@/views/survey/Settings.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.settings',
        },
        beforeEnter: [guardSurveySettingsAccess],
      },
      {
        path: 'form/:formId/edit',
        name: 'SurveyFormEdit',
        component: () => import('@/views/survey/form/Edit.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.formEdit',
          editRouteName: 'SurveyFormEdit',
        },
        beforeEnter: [guardSurveySettingsAccess],
      },
      {
        path: 'form/new',
        name: 'SurveyFormNew',
        component: () => import('@/views/survey/form/Edit.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.formNew',
          editRouteName: 'SurveyFormEdit',
        },
        beforeEnter: [guardSurveySettingsAccess],
      },
      {
        path: ':surveyId',
        name: 'Survey',
        component: () => import('@/views/survey/Survey.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.details',
        },
        beforeEnter: [guardSurveyManage],
      },
      {
        path: ':surveyId/edit',
        name: 'SurveyEdit',
        component: () => import('@/views/survey/SurveyEdit.vue'),
        meta: {
          requiresAuth: true,
          titleTranslationKey: 'pageTitle.survey.edit',
        },
        beforeEnter: [guardSurveyManage],
      },
    ],
  },
  {
    // Outside the guarded routes: reachable by any participant, whatever their rights (the API only serves them their own answers)
    path: '/survey/:surveyId/answer',
    name: 'SurveyAnswer',
    component: () => import('@/views/survey/SurveyAnswer.vue'),
    meta: {
      requiresAuth: true,
      titleTranslationKey: 'pageTitle.survey.answer',
    },
  },
]

export default surveyRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }))
